export function hasIdentityMerge() {
  try { const value = JSON.parse(sessionStorage.getItem('steos:identity:merge') || 'null');
    return typeof value?.operation_id === 'string' && typeof value?.receipt === 'string' && /^[a-f\d]{64}$/i.test(value.receipt);
  } catch { return false; }
}
